import { IAppState } from '../../../AppModulesWrapper';

import { selectIsSubagent } from '../user';
import { selectPlacingMoneySource } from './selectPlacingMoneySource';
import { EPublishTermsAvailableMoneySources } from '../../types/reducers/publishTerms';
import { EMoneySource } from '../../types/reducers/user';

export const selectIsUnavailableImportOfferPromotionForSelfMoneySource = (state: IAppState): boolean => {
  const isSubagent = selectIsSubagent(state);
  const placingMoneySource = selectPlacingMoneySource(state);

  return (
    isSubagent &&
    placingMoneySource === EMoneySource.Self &&
    state.servicePickerWidget.publishTerms.availableMoneySources === EPublishTermsAvailableMoneySources.Master
  );
};
